var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShow
    ? _c(
        "div",
        { staticClass: "_component-side-helper", style: _vm.style },
        [
          _vm.isShowLoginModal
            ? _c("LoginModal", {
                attrs: { initState: _vm.LOGIN_STATE.REGIST, modal: true },
                on: { close: _vm.triggerLoginModal }
              })
            : _vm._e(),
          _vm.isShowWelfare
            ? _c("Welfare", {
                on: {
                  submit: _vm.handleClickSubmitWelfare,
                  close: _vm.triggerWelfare
                }
              })
            : _vm._e(),
          _vm.isShowOfficial
            ? _c("Official", {
                staticClass: "bar-pop",
                on: { close: _vm.triggerOfficial }
              })
            : _vm._e(),
          _vm.isShowServe
            ? _c("Serve", {
                staticClass: "bar-pop",
                on: { close: _vm.triggerServe }
              })
            : _vm._e(),
          _c("div", { staticClass: "bars-wrap" }, [
            _vm.$store.state.Deadline.rdDiff !== Infinity &&
            !_vm.$store.getters.isRdOver
              ? _c(
                  "div",
                  {
                    staticClass: "bar-item",
                    on: { click: _vm.triggerWelfare }
                  },
                  [_vm._m(0)]
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "bar-item", on: { click: _vm.triggerServe } },
              [_vm._m(1)]
            ),
            _c(
              "div",
              { staticClass: "bar-item", on: { click: _vm.triggerOfficial } },
              [_vm._m(2)]
            ),
            _c(
              "div",
              { staticClass: "bar-item", on: { click: _vm.handleClickGoTop } },
              [_vm._m(3)]
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-content" }, [
      _c("div", { staticClass: "item-icon img-wrap" }, [
        _c("img", {
          attrs: {
            src:
              "//hsylc.oss-cn-hangzhou.aliyuncs.com/2024/side-helper/icon-1.png",
            alt: ""
          }
        })
      ]),
      _c("p", { staticClass: "text3 item-name color-gray-1" }, [
        _vm._v("限时福利")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-content" }, [
      _c("div", { staticClass: "item-icon img-wrap" }, [
        _c("img", {
          attrs: {
            src:
              "//hsylc.oss-cn-hangzhou.aliyuncs.com/2024/side-helper/icon-2.png",
            alt: ""
          }
        })
      ]),
      _c("p", { staticClass: "text3 item-name color-gray-1" }, [
        _vm._v("在线客服")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-content" }, [
      _c("div", { staticClass: "item-icon img-wrap" }, [
        _c("img", {
          attrs: {
            src:
              "//hsylc.oss-cn-hangzhou.aliyuncs.com/2024/side-helper/icon-3.png",
            alt: ""
          }
        })
      ]),
      _c("p", { staticClass: "text3 item-name color-gray-1" }, [
        _vm._v("公众号")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-content" }, [
      _c("div", { staticClass: "item-icon img-wrap" }, [
        _c("img", {
          attrs: {
            src:
              "//hsylc.oss-cn-hangzhou.aliyuncs.com/2024/side-helper/icon-4.png",
            alt: ""
          }
        })
      ]),
      _c("p", { staticClass: "text3 item-name color-gray-1" }, [
        _vm._v("返回顶部")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }